// extracted by mini-css-extract-plugin
export default {"fadeIn":"Ht4igHsBedImJ0MVDoRi","wrapperClasses":"OA9UorKlagCk3nVCXIhn"};